"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[112],{

/***/ 8859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4767);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7573);


var Button = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("button", {
    all: "unset",
    boxSizing: "border-box",
    padding: "13px 20px",
    maxHeight: 50,
    textAlign: "center",
    fontFamily: "$raleway",
    fontSize: (0,polished__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hO)(11),
    fontWeight: "bold",
    lineHeight: "120%",
    letterSpacing: "1.2px",
    textTransform: "uppercase",
    border: "2px solid transparent",
    cursor: "pointer",
    "&:disabled": {
        opacity: 0.3,
        cursor: "not-allowed"
    },
    variants: {
        shape: {
            square: {
                borderRadius: 8
            },
            rounded: {
                borderRadius: 32
            }
        },
        color: {
            inverse: {
                background: "$white",
                color: "$emerald500",
                "&:hover": {
                    background: "$grey200"
                }
            },
            primary: {
                background: "$emerald500",
                color: "white",
                "&:hover": {
                    backgroundColor: "$emerald600"
                }
            },
            secondary: {
                background: "transparent",
                color: "$emerald500",
                borderColor: "$emerald500"
            },
            transparent: {
                background: "transparent",
                color: "$emerald500",
                "&:hover": {
                    color: "$emerald600"
                }
            }
        }
    },
    defaultVariants: {
        shape: "square",
        color: "primary"
    }
});
// const Button = ({
//   color = "primary",
//   shape = "square",
//   ...props
// }: ButtonProps) => {
//   return (
//     <S.Container {...props} color={color} shap={shape}>
//       {props.children}
//     </S.Container>
//   );
// };
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 1344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8641);





var Container = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        maxW: "7xl",
        children: props.children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Container);


/***/ }),

/***/ 7386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(8641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/index.esm.js
var dist_index_esm = __webpack_require__(3382);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./public/images/logo-central-da-grama.png
/* harmony default export */ var logo_central_da_grama = ({"src":"/_next/static/media/logo-central-da-grama.a14415b9.png","height":78,"width":100,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAP1BMVEVMaXGKxEO+6cqQ0YUysT+JwzU/t0tMtkNvu0M9uko1tEWv4aqUzURhw22T1ZVXuUWCwjOAwT3T9Nl83IVgymsfugZjAAAAE3RSTlMAOfjsm2hVHg+66vLXwYLJe9f+L6kYwQAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAADBJREFUeJwdxscRACAMxMAjnsmx/1oZ85EWAGBEGxmqHimPxY9r3VT4s0tQ0LdOygMWiwEJOPrFagAAAABJRU5ErkJggg=="});
// EXTERNAL MODULE: ./styles/stitches.config.ts
var stitches_config = __webpack_require__(4767);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 6 modules
var polished_esm = __webpack_require__(7573);
// EXTERNAL MODULE: ./components/Button/index.tsx
var Button = __webpack_require__(8859);
;// CONCATENATED MODULE: ./components/Footer/styles.ts




var Footer = (0,stitches_config/* styled */.zo)("footer", {
    "& hr": {
        my: 25,
        width: "100%",
        borderColor: "$emerald500",
        "@md": {
            maxWidth: 600
        }
    },
    "& h4": {
        "@md": {
            maxWidth: 340
        },
        "& span": {
            color: "$emerald500"
        }
    }
});
var Left = (0,stitches_config/* styled */.zo)("div", {
    paddingTop: 50,
    paddingBottom: 50,
    display: "flex",
    alignItems: "flex-end",
    flexDirection: "column",
    backgroundColor: "$emerald50",
    "@lg": {
        paddingTop: 112,
        paddingBottom: 112,
        borderRadius: "0 128px 0 0"
    }
});
var Content = (0,stitches_config/* styled */.zo)("div", {
    width: "100%",
    paddingLeft: 16,
    paddingRight: 16,
    textAlign: "center",
    "@md": {
        textAlign: "left",
        maxWidth: 600
    },
    "@lg": {
        paddingRight: 50
    }
});
var Top = (0,stitches_config/* styled */.zo)("div", {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%"
});
var LogoWrap = (0,stitches_config/* styled */.zo)("div", {
    display: "flex",
    alignItems: "center"
});
var Logo = (0,stitches_config/* styled */.zo)((image_default()), {});
var Socials = (0,stitches_config/* styled */.zo)("div", {
    display: "flex",
    alignItems: "center"
});
var Social = (0,stitches_config/* styled */.zo)("a", {
    width: 32,
    height: 32,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "100%",
    "&.instagram": {
        backgroundColor: "#962FBF"
    },
    "&.google": {
        backgroundColor: "#BB001B"
    },
    "&.facebook": {
        backgroundColor: "#2F80ED"
    },
    "&.twitter": {
        backgroundColor: "#56CCF2"
    },
    "&.feeds": {
        backgroundColor: "#F26522"
    },
    "&:not(:last-of-type)": {
        marginRight: 10
    },
    "&:hover": {
        opacity: 0.8
    }
});
var styles_Button = (0,stitches_config/* styled */.zo)(Button/* default */.Z, {
    display: "inline-flex",
    alignItems: "center",
    margin: "40px auto",
    "& svg": {
        marginLeft: 5,
        marginTop: "-2px"
    }
});
var LogoText = (0,stitches_config/* styled */.zo)("p", {
    fontFamily: "$domine",
    color: "$gray900",
    lineHeight: "120%",
    "@md": {
        fontSize: (0,polished_esm/* rem */.hO)(20)
    }
});
var Copyright = (0,stitches_config/* styled */.zo)("p", {
    fontFamily: "$raleway",
    fontSize: (0,polished_esm/* rem */.hO)(13),
    color: "$grey600",
    "& a": {
        color: "$emerald900",
        fontWeight: "bold"
    }
});
var Right = (0,stitches_config/* styled */.zo)("div", {
    padding: 16,
    "@md": {
        paddingTop: 112
    },
    "@lg": {
        paddingLeft: 90,
        maxWidth: 700
    }
});
var Menu = (0,stitches_config/* styled */.zo)("nav", {
    display: "flex",
    paddingInline: 40,
    justifyContent: "space-between",
    "@lg": {
        paddingInline: 0,
        justifyContent: "flex-start"
    }
});
var Ul = (0,stitches_config/* styled */.zo)("ul", {
    listStyle: "none",
    "@lg": {
        "&:not(:last-of-type)": {
            marginRight: 160
        }
    }
});
var Label = (0,stitches_config/* styled */.zo)("p", {
    fontFamily: "$domine",
    fontWeight: "bold",
    fontSize: (0,polished_esm/* rem */.hO)(16),
    color: "$grey900",
    "@lg": {
        marginBottom: 24
    }
});
var MenuLink = (0,stitches_config/* styled */.zo)("a", {
    display: "block",
    fontFamily: "$raleway",
    fontSize: (0,polished_esm/* rem */.hO)(13),
    color: "$grey600",
    lineHeight: "180%",
    cursor: "pointer",
    "&:not(:last-of-type)": {
        marginBottom: 8
    },
    "&:hover": {
        color: "$black"
    }
});
var Phones = (0,stitches_config/* styled */.zo)("div", {
    display: "flex",
    marginTop: 56,
    justifyContent: "space-between",
    "@lg": {
        justifyContent: "flex-start"
    }
});
var Phone = (0,stitches_config/* styled */.zo)("div", {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    "@lg": {
        flexDirection: "row",
        alignItems: "center",
        "&:not(:last-of-type)": {
            marginRight: 20
        }
    }
});
var PhoneText = (0,stitches_config/* styled */.zo)("p", {
    marginLeft: 10,
    fontFamily: "$domine",
    color: "$emerald500",
    fontSize: (0,polished_esm/* rem */.hO)(12),
    marginTop: 5,
    "@md": {
        fontSize: (0,polished_esm/* rem */.hO)(16)
    },
    "@lg": {
        marginTop: 0
    }
});

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./components/Footer/index.tsx







var Footer_Footer = function() {
    var router = (0,next_router.useRouter)();
    var dataAtual = new Date();
    var anoAtual = dataAtual.getFullYear();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* SimpleGrid */.MI, {
            columns: [
                1,
                null,
                2
            ],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Left, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Top, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LogoWrap, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                                                src: logo_central_da_grama,
                                                alt: "logo central da grama",
                                                width: 30,
                                                height: 30,
                                                layout: "fixed",
                                                objectFit: "cover"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoText, {
                                                children: "CG"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Socials, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "https://www.instagram.com/centraldagrama/",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Social, {
                                                    className: "instagram",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    title: "Siga-nos no Instagram!",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        width: "18",
                                                        height: "19",
                                                        viewBox: "0 0 18 19",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M9.00201 4.48464C6.44808 4.48464 4.38806 6.54511 4.38806 9.09961C4.38806 11.6541 6.44808 13.7146 9.00201 13.7146C11.5559 13.7146 13.616 11.6541 13.616 9.09961C13.616 6.54511 11.5559 4.48464 9.00201 4.48464ZM9.00201 12.0999C7.35159 12.0999 6.00234 10.7544 6.00234 9.09961C6.00234 7.44481 7.34757 6.09927 9.00201 6.09927C10.6564 6.09927 12.0017 7.44481 12.0017 9.09961C12.0017 10.7544 10.6524 12.0999 9.00201 12.0999ZM14.8809 4.29586C14.8809 4.89432 14.399 5.37229 13.8047 5.37229C13.2064 5.37229 12.7285 4.8903 12.7285 4.29586C12.7285 3.70142 13.2104 3.21943 13.8047 3.21943C14.399 3.21943 14.8809 3.70142 14.8809 4.29586ZM17.9368 5.38835C17.8685 3.94642 17.5392 2.66917 16.4831 1.61685C15.431 0.564521 14.154 0.235167 12.7124 0.162869C11.2267 0.0785227 6.77334 0.0785227 5.28756 0.162869C3.84997 0.23115 2.57301 0.560504 1.5169 1.61283C0.460792 2.66516 0.135527 3.94241 0.063246 5.38434C-0.021082 6.87044 -0.021082 11.3248 0.063246 12.8109C0.131511 14.2528 0.460792 15.53 1.5169 16.5824C2.57301 17.6347 3.84596 17.9641 5.28756 18.0363C6.77334 18.1207 11.2267 18.1207 12.7124 18.0363C14.154 17.9681 15.431 17.6387 16.4831 16.5824C17.5352 15.53 17.8645 14.2528 17.9368 12.8109C18.0211 11.3248 18.0211 6.87446 17.9368 5.38835ZM16.0173 14.4054C15.7041 15.1927 15.0977 15.7992 14.3066 16.1165C13.122 16.5864 10.3111 16.4779 9.00201 16.4779C7.69292 16.4779 4.87797 16.5824 3.69738 16.1165C2.91032 15.8032 2.30396 15.1967 1.98673 14.4054C1.5169 13.2206 1.62532 10.409 1.62532 9.09961C1.62532 7.79023 1.52091 4.97465 1.98673 3.7938C2.29994 3.00656 2.9063 2.40007 3.69738 2.08276C4.88199 1.61283 7.69292 1.72128 9.00201 1.72128C10.3111 1.72128 13.126 1.61685 14.3066 2.08276C15.0937 2.39605 15.7001 3.00254 16.0173 3.7938C16.4871 4.97867 16.3787 7.79023 16.3787 9.09961C16.3787 10.409 16.4871 13.2246 16.0173 14.4054Z",
                                                            fill: "white"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "https://g.page/centraldagrama",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Social, {
                                                    className: "google",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    title: "Conhe\xe7a nossa empresa, fa\xe7a uma visita!",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        width: "18",
                                                        height: "12",
                                                        viewBox: "0 0 18 12",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M10.9354 5.27989C10.9891 5.569 11.0275 5.8581 11.0275 6.23312C11.0275 9.507 8.87106 11.8276 5.625 11.8276C2.51707 11.8276 0 9.26479 0 6.10032C0 2.93585 2.51707 0.373047 5.625 0.373047C7.14445 0.373047 8.41063 0.935602 9.3929 1.87323L7.86577 3.36561C7.45137 2.9593 6.72237 2.48268 5.625 2.48268C3.70652 2.48268 2.14102 4.10007 2.14102 6.10032C2.14102 8.10057 3.70652 9.71796 5.625 9.71796C7.85042 9.71796 8.6869 8.08494 8.81733 7.24888H5.625V5.27986H10.9354V5.27989ZM16.3672 5.4719V3.80941H14.7265V5.4719H13.0937V7.14238H14.7265V8.80487H16.3672V7.14238H18V5.4719H16.3672Z",
                                                            fill: "white"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "https://www.facebook.com/centraldagrama",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Social, {
                                                    className: "facebook",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    title: "Curta nossa fanpage no Facebook!",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        width: "8",
                                                        height: "14",
                                                        viewBox: "0 0 8 14",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M7.97092 0.964871C7.97092 0.86913 7.93289 0.77731 7.86519 0.709611C7.79749 0.641911 7.70567 0.603878 7.60993 0.603878H5.80496C4.89607 0.558603 4.00621 0.874905 3.3298 1.48367C2.65339 2.09244 2.24542 2.94419 2.19504 3.85281V5.80217H0.390076C0.294335 5.80217 0.202515 5.8402 0.134816 5.9079C0.0671164 5.9756 0.0290833 6.06742 0.0290833 6.16316V8.04032C0.0290833 8.13607 0.0671164 8.22788 0.134816 8.29558C0.202515 8.36328 0.294335 8.40132 0.390076 8.40132H2.19504V13.2386C2.19504 13.3344 2.23307 13.4262 2.30077 13.4939C2.36847 13.5616 2.46029 13.5996 2.55603 13.5996H4.72199C4.81773 13.5996 4.90955 13.5616 4.97725 13.4939C5.04495 13.4262 5.08298 13.3344 5.08298 13.2386V8.40132H6.97458C7.05486 8.40247 7.13323 8.37683 7.1973 8.32845C7.26137 8.28007 7.30749 8.21171 7.32835 8.13418L7.84818 6.25702C7.86254 6.20368 7.86447 6.14776 7.85382 6.09356C7.84317 6.03935 7.82023 5.98832 7.78675 5.94438C7.75327 5.90044 7.71016 5.86477 7.66073 5.84012C7.6113 5.81546 7.55687 5.80248 7.50163 5.80217H5.08298V3.85281C5.10094 3.6741 5.18486 3.5085 5.31836 3.38835C5.45186 3.2682 5.62536 3.20212 5.80496 3.20302H7.60993C7.70567 3.20302 7.79749 3.16499 7.86519 3.09729C7.93289 3.02959 7.97092 2.93777 7.97092 2.84203V0.964871Z",
                                                            fill: "white"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "https://twitter.com/centraldagrama",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Social, {
                                                    className: "twitter",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    title: "Siga-nos no Twitter!",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        width: "16",
                                                        height: "14",
                                                        viewBox: "0 0 16 14",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M15.9957 2.14165C15.4076 2.40223 14.7759 2.5783 14.1118 2.65789C14.797 2.24785 15.3097 1.6025 15.5541 0.842247C14.9103 1.22466 14.2057 1.49385 13.4709 1.63809C12.9767 1.11048 12.3222 0.76078 11.609 0.643269C10.8957 0.525759 10.1636 0.647014 9.52634 0.988212C8.88907 1.32941 8.38227 1.87146 8.08462 2.5302C7.78697 3.18895 7.71514 3.92753 7.88027 4.63128C6.57572 4.56578 5.29952 4.22671 4.13449 3.63607C2.96947 3.04542 1.94165 2.21641 1.11776 1.20284C0.836044 1.68879 0.67406 2.25222 0.67406 2.85227C0.673745 3.39245 0.806769 3.92435 1.06133 4.40079C1.31589 4.87723 1.68411 5.28347 2.13333 5.58347C1.61236 5.56689 1.10288 5.42612 0.647297 5.17287V5.21513C0.647244 5.97276 0.909313 6.70707 1.38903 7.29346C1.86876 7.87986 2.53658 8.28223 3.2792 8.43229C2.79591 8.56309 2.28922 8.58235 1.79739 8.48863C2.00691 9.14053 2.41504 9.71058 2.96464 10.119C3.51424 10.5274 4.1778 10.7537 4.86242 10.7663C3.70024 11.6786 2.26495 12.1735 0.787449 12.1713C0.525725 12.1714 0.264221 12.1561 0.00428772 12.1255C1.50404 13.0898 3.24986 13.6016 5.03286 13.5996C11.0686 13.5996 14.3681 8.60061 14.3681 4.26506C14.3681 4.1242 14.3646 3.98193 14.3583 3.84108C15.0001 3.37694 15.5541 2.80219 15.9943 2.14376L15.9957 2.14165Z",
                                                            fill: "white"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "https://feeds.feedburner.com/centraldagrama",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Social, {
                                                    className: "feeds",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    title: "Inscreva-se em nosso Feed de Not\xedcias!",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        width: "18",
                                                        height: "19",
                                                        viewBox: "0 0 18 19",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M5.14611 15.5265C5.14611 16.9476 3.99411 18.0996 2.57303 18.0996C1.15196 18.0996 0 16.9476 0 15.5265C0 14.1054 1.152 12.9534 2.57307 12.9534C3.99415 12.9534 5.14611 14.1055 5.14611 15.5265ZM12.2039 17.4249C11.8682 11.2133 6.89287 6.23174 0.674638 5.89573C0.307607 5.87588 0 6.17079 0 6.53834V8.46968C0 8.80778 0.260759 9.09132 0.598138 9.11326C5.09138 9.40592 8.69303 12.9986 8.98629 17.5014C9.00827 17.8388 9.29181 18.0995 9.62987 18.0995H11.5612C11.9288 18.0996 12.2237 17.792 12.2039 17.4249ZM17.9996 17.4365C17.6623 8.04198 10.1035 0.438932 0.663066 0.100027C0.300254 0.087009 0 0.380111 0 0.743123V2.67442C0 3.02096 0.27462 3.30301 0.620879 3.31724C8.30217 3.63219 14.4675 9.79866 14.7824 17.4787C14.7966 17.825 15.0786 18.0996 15.4252 18.0996H17.3565C17.7195 18.0996 18.0126 17.7993 17.9996 17.4365Z",
                                                            fill: "white"
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                    children: [
                                        "Grama de qualidade ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Direto do Produtor,"
                                        }),
                                        " compre com melhor pre\xe7o por m2!"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/comprar-grama",
                                    passHref: true,
                                    title: "Fa\xe7a seu or\xe7amento",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Button, {
                                        shape: "rounded",
                                        as: "a",
                                        title: "cotar pre\xe7o de grama",
                                        "aria-label": "fa\xe7a seu or\xe7amento",
                                        children: [
                                            "fa\xe7a seu or\xe7amento ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* ArrowForwardIcon */.mr, {
                                                w: 4,
                                                h: 4
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Copyright, {
                                    children: [
                                        "\xa9",
                                        anoAtual,
                                        " - Desenvolvido com ❤️ by",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://www.versatilnow.com/",
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                rel: "noreferrer",
                                                title: "Versatilnow",
                                                "aria-label": "abrir link versatilnow",
                                                children: "Versatilnow"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Right, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Ul, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                                children: "Links \xfateis"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/mapa-do-site",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuLink, {
                                                    title: "mapa central da grama",
                                                    children: "Mapa do site"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Ul, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                                children: "P\xe1ginas"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuLink, {
                                                    title: "p\xe1gina inicial central da grama",
                                                    children: "In\xedcio"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/dicas",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuLink, {
                                                    title: "dicas sobre grama",
                                                    children: "Dicas"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/fotos",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuLink, {
                                                    title: "fotos de grama",
                                                    children: "Fotos"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/gramas",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuLink, {
                                                    title: "tipos de gramas",
                                                    children: "Gramas"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/comprar-grama",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuLink, {
                                                    title: "comprar grama pre\xe7o",
                                                    children: "Or\xe7amento"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/contato",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuLink, {
                                                    title: "or\xe7ar grama",
                                                    children: "Contato"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Phones, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Phone, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            width: "11",
                                            height: "17",
                                            viewBox: "0 0 11 17",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M8.45459 0.5H2.63641C1.42914 0.5 0.45459 1.47455 0.45459 2.68182V14.3182C0.45459 15.5255 1.42914 16.5 2.63641 16.5H8.45459C9.66186 16.5 10.6364 15.5255 10.6364 14.3182V2.68182C10.6364 1.47455 9.66186 0.5 8.45459 0.5ZM9.18186 12.8636H1.90914V2.68182H9.18186V12.8636ZM7.00004 15.0455H4.09095V14.3182H7.00004V15.0455Z",
                                                fill: "#111827"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneText, {
                                            children: "(15) 3373-1271"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Phone, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            width: "11",
                                            height: "17",
                                            viewBox: "0 0 11 17",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M8.45459 0.5H2.63641C1.42914 0.5 0.45459 1.47455 0.45459 2.68182V14.3182C0.45459 15.5255 1.42914 16.5 2.63641 16.5H8.45459C9.66186 16.5 10.6364 15.5255 10.6364 14.3182V2.68182C10.6364 1.47455 9.66186 0.5 8.45459 0.5ZM9.18186 12.8636H1.90914V2.68182H9.18186V12.8636ZM7.00004 15.0455H4.09095V14.3182H7.00004V15.0455Z",
                                                fill: "#111827"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneText, {
                                            children: "(11) 9 9617-2172"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Phone, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            width: "11",
                                            height: "17",
                                            viewBox: "0 0 11 17",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M8.45459 0.5H2.63641C1.42914 0.5 0.45459 1.47455 0.45459 2.68182V14.3182C0.45459 15.5255 1.42914 16.5 2.63641 16.5H8.45459C9.66186 16.5 10.6364 15.5255 10.6364 14.3182V2.68182C10.6364 1.47455 9.66186 0.5 8.45459 0.5ZM9.18186 12.8636H1.90914V2.68182H9.18186V12.8636ZM7.00004 15.0455H4.09095V14.3182H7.00004V15.0455Z",
                                                fill: "#111827"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneText, {
                                            children: "(11) 9 4834-2269"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_Footer = (Footer_Footer);


/***/ }),

/***/ 6697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Navbar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/index.esm.js
var index_esm = __webpack_require__(3382);
;// CONCATENATED MODULE: ./public/images/logo-central-da-grama.svg
/* harmony default export */ var logo_central_da_grama = ({"src":"/_next/static/media/logo-central-da-grama.bc545671.svg","height":39,"width":50});
// EXTERNAL MODULE: ./styles/stitches.config.ts
var stitches_config = __webpack_require__(4767);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 6 modules
var polished_esm = __webpack_require__(7573);
;// CONCATENATED MODULE: ./components/FloatButton/styles.ts


var FloatButton = (0,stitches_config/* styled */.zo)("div", {
    position: "fixed",
    "z-index": "1000",
    "bottom": (0,polished_esm/* rem */.hO)(20),
    "right": (0,polished_esm/* rem */.hO)(20),
    "display": "flex",
    "flexDirection": "column",
    "gap": (0,polished_esm/* rem */.hO)(20),
    "@lg": {
        "bottom": (0,polished_esm/* rem */.hO)(40),
        "right": (0,polished_esm/* rem */.hO)(40)
    }
});
var Link = (0,stitches_config/* styled */.zo)("a", {
    "display": "flex",
    "width": (0,polished_esm/* rem */.hO)(50),
    "height": (0,polished_esm/* rem */.hO)(50),
    "border-radius": (0,polished_esm/* rem */.hO)(50),
    "alignItems": "center",
    "justifyContent": "center",
    "cursor": "pointer",
    "svg": {
        width: (0,polished_esm/* rem */.hO)(15),
        color: "#fff"
    },
    variants: {
        color: {
            green: {
                backgroundColor: "$emerald400"
            },
            gray: {
                backgroundColor: "$grey400"
            }
        }
    },
    "@lg": {
        "width": (0,polished_esm/* rem */.hO)(60),
        "height": (0,polished_esm/* rem */.hO)(60),
        "svg": {
            width: (0,polished_esm/* rem */.hO)(25)
        }
    }
});

;// CONCATENATED MODULE: ./components/FloatButton/index.tsx



var FloatButton_FloatButton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FloatButton, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                href: "https://api.whatsapp.com/send/?phone=5511996172172&type=phone_number&app_absent=0",
                target: "_blank",
                rel: "noreferrer",
                color: "green",
                title: "comprar grama pelo whatsapp",
                "aria-label": "Whatsapp",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 448 512",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                color: "gray",
                onClick: function() {
                    return window && window.scrollTo(0, 0);
                },
                href: "#",
                title: "topo central da grama",
                "aria-label": "Voltar ao topo",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ChevronUpIcon */.g8, {})
            })
        ]
    });
};
/* harmony default export */ var components_FloatButton = (FloatButton_FloatButton);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var dist_index_esm = __webpack_require__(7741);
// EXTERNAL MODULE: ./components/Button/index.tsx
var Button = __webpack_require__(8859);
;// CONCATENATED MODULE: ./components/Navbar/styles.ts





var Container = (0,stitches_config/* styled */.zo)("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 10,
    position: "relative",
    borderRadius: 32,
    backgroundColor: "white",
    transition: "border-radius 0.2s",
    variants: {
        open: {
            true: {
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0
            }
        }
    }
});
var LogoWrap = (0,stitches_config/* styled */.zo)("div", {
    display: "flex",
    alignItems: "center"
});
var LogoContent = (0,stitches_config/* styled */.zo)("span", {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    "&:hover": {
        color: "$emerald500"
    }
});
var LogoText = (0,stitches_config/* styled */.zo)("p", {
    fontFamily: "$domine",
    color: "$gray900",
    lineHeight: "120%",
    "@md": {
        fontSize: (0,polished_esm/* rem */.hO)(20)
    }
});
var LogoImage = (0,stitches_config/* styled */.zo)((image_default()), {});
var Navbar = (0,stitches_config/* styled */.zo)("nav", {
    display: "none",
    variants: {
        open: {
            true: {
                "@maxmd": {
                    position: "absolute",
                    display: "flex",
                    flexDirection: "column",
                    background: "white",
                    right: "0",
                    top: "65px",
                    zIndex: "99",
                    width: "100%",
                    padding: "20px",
                    borderBottomRightRadius: "10px",
                    borderBottomLeftRadius: "10px"
                }
            }
        }
    },
    "@md": {
        display: "flex"
    }
});
var Navbar_Link = (0,stitches_config/* styled */.zo)("a", {
    fontFamily: "$raleway",
    fontSize: (0,polished_esm/* rem */.hO)(14),
    lineHeight: "180%",
    color: "$gray600",
    cursor: "pointer",
    "@maxmd": {
        padding: "10px 0"
    },
    "&:hover": {
        color: "$emerald500"
    },
    "&:not(:last-of-type)": {
        marginRight: 32
    }
});
var styles_Button = (0,stitches_config/* styled */.zo)(Button/* default */.Z, {
    display: "none",
    "& svg": {
        marginRight: 10
    },
    "@md": {
        display: "flex",
        alignItems: "center",
        "& span": {
            marginRight: "5px !important"
        }
    }
});
var ButtonIcon = (0,stitches_config/* styled */.zo)((image_default()), {
    marginRight: 10
});
var ButtonMenu = (0,stitches_config/* styled */.zo)(dist_index_esm/* IconButton */.hU, {
    marginRight: 19,
    borderRadius: "32px !important",
    "@md": {
        display: "none !important"
    }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/Navbar/index.js







var Navbar_Navbar = function() {
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        open: isOpen,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoWrap, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LogoContent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoImage, {
                                src: logo_central_da_grama,
                                alt: "logo central da grama",
                                title: "logotipo central da grama",
                                width: 70,
                                height: 60,
                                layout: "fixed",
                                priority: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoText, {
                                title: "central da grama",
                                children: "central da grama"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navbar, {
                open: isOpen,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_Link, {
                            title: "in\xedcio central da grama",
                            alt: "in\xedcio",
                            children: "In\xedcio"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/comprar-grama",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_Link, {
                            title: "comprar grama",
                            alt: "comprar grama",
                            children: "Or\xe7amento"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/dicas",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_Link, {
                            title: "dicas de grama",
                            alt: "dicas",
                            children: "Dicas"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/fotos",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_Link, {
                            title: "fotos de grama",
                            alt: "fotos",
                            children: "Fotos"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/gramas",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_Link, {
                            title: "tipos de gramas",
                            alt: "gramas",
                            children: "Gramas"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/contato",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_Link, {
                            title: "cotar grama",
                            alt: "Contato",
                            children: "Contato"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Button, {
                shape: "rounded",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: "https://api.whatsapp.com/send/?phone=5511996172172&type=phone_number&app_absent=0",
                    target: "_blank",
                    without: "true",
                    rel: "noreferrer",
                    title: "ver pre\xe7o de grama pelo whatsapp",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* PhoneIcon */.qW, {}),
                        "whatsapp"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenu, {
                onClick: function() {
                    setIsOpen(function(value) {
                        return !value;
                    });
                },
                variant: "outline",
                "aria-label": "abrir menu",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HamburgerIcon */.Uq, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FloatButton, {})
        ]
    });
};
/* harmony default export */ var components_Navbar = (Navbar_Navbar);


/***/ })

}]);